<!-- Show credit/refi offer information -->
<section
  id="offer-information"
  aria-label="Selected cross sell offer details"
  class="cross-sell-panel-container bl-width--100 bl-display--flex bl-flex-direction--column bl-block-module bl-padding-y--24 bl-padding-x--40"
>
  <h3 class="bl-text-style--display-6 bl-margin-bottom--16">Selected Offer</h3>
  @if (activeCrossSellOffer(); as offer) {
    <div class="bl-display--flex bl-margin-bottom--24">
      <dx-product-image
        class="cross-sell-image dx-no-bg-highlight"
        [flowType]="'ola'"
        [mask]="'confetti'"
        [product]="productDetails().loanType"
        [size]="'64px'"
      ></dx-product-image>
      <div class="bl-display--flex bl-flex-direction--column bl-gap--4">
        <span class="bl-text-style--display-6">{{ offer.crossSellOffer?.displayName || '—' }}</span>
        <p class="bl-text-style--secondary-text-1 bl-margin-bottom--0" [innerHTML]="productDetails().loanDescription"></p>
      </div>
    </div>
    <div class="bl-display--flex bl-text-align--center bl-justify-content--space-between bl-border-top--solid bl-border-bottom--solid">
      <div class="bl-display--flex bl-flex-direction--column bl-padding-y--16">
        <span class="bl-text-style--tertiary-text-2 bl-font-color--steel bl-margin-bottom--4">Estimated Payment</span>
        <h4 class="bl-margin-bottom--0">
          @if (productDetails().estimatedPayment !== null) {
            {{ productDetails().estimatedPayment | currency: 'USD' : 'symbol' : '1.0-2' }}
          } @else {
            N/A
          }
        </h4>
      </div>
      <div class="bl-border"></div>
      <div class="bl-display--flex bl-flex-direction--column bl-padding-y--16">
        <span class="bl-text-style--tertiary-text-2 bl-font-color--steel bl-margin-bottom--4">Term</span>
        <h4 class="bl-margin-bottom--0">
          @if (productDetails().term !== null) {
            {{ productDetails().term }} months
          } @else {
            N/A
          }
        </h4>
      </div>
      <div class="bl-border"></div>
      <div class="bl-display--flex bl-flex-direction--column bl-padding-y--16">
        <span class="bl-text-style--tertiary-text-2 bl-font-color--steel bl-margin-bottom--4">Estimated Rate</span>
        <h4 class="bl-margin-bottom--0">
          @if (productDetails().rate !== null) {
            {{ productDetails().rate | number: '1.0-2' }}% APR
          } @else {
            N/A
          }
        </h4>
      </div>
      <div class="bl-border"></div>
      <div class="bl-display--flex bl-flex-direction--column bl-padding-y--16">
        <span class="bl-text-style--tertiary-text-2 bl-font-color--steel bl-margin-bottom--4">Loan Amount</span>
        <h4 class="bl-margin-bottom--0">
          @if (productDetails().amount !== null) {
            {{ productDetails().amount | currency: 'USD' : 'symbol' : '1.0-2' }}
          } @else {
            N/A
          }
        </h4>
      </div>
    </div>
  } @else {
    <p class="bl-text-style--secondary-text-1 bl-font-style--italic">No offer selected</p>
  }
</section>
<!-- Disclosures rendered inside accordions -->
@if (disclosures()?.length) {
  <ea-accordion-group
    #oneClickDisclosuresGroup
    class="bl-width--100 bl-padding-y--24 bl-padding-x--32 cross-sell-panel-container bl-block-module"
  >
    @for (item of disclosures(); track item.disclosureId || $index; let i = $index; let last = $last) {
      <div id="one-click-disclosure-card-{{ i }}" class="bl-padding-y--16" [class.bl-border-bottom]="!last">
        <ea-accordion
          #disclosureRef
          controllerClass="bl-display--flex bl-width--100 bl-font-color--base"
          controllerPosition="above"
          uniqueId="one-click-disclosure-{{ i }}"
          class="bl-width--100"
          [controllerAriaLabel]="'Accordion ' + (item.title || 'Disclosure')"
          [controllerInnerHtml]="disclosureTitleHtml(item)"
          [defaultExpanded]="item.isOpen === true"
          (click)="toggleDisclosure(i)"
        >
          <div class="bl-margin-top--24">
            @if (item.isPDFFile) {
              @if (item.url) {
                <ea-pdf-embed [pdfSrc]="item.url"></ea-pdf-embed>
              } @else {
                <ea-orbit-loader [loading]="!item.url"></ea-orbit-loader>
              }
            } @else if (item.isLinkType) {
              @if (item.content) {
                <div class="bl-margin-bottom--8" [innerHTML]="item.content"></div>
              }
              <a rel="noopener noreferrer" target="_blank" [href]="item.url">{{ item.urlDisplayText }}</a>
            } @else {
              <div [innerHTML]="item.content"></div>
            }
          </div>
        </ea-accordion>
      </div>
    }
  </ea-accordion-group>
}

<ng-content></ng-content>

<section id="apply" class="cross-sell-panel-container bl-width--100 bl-display--flex bl-flex-direction--column bl-padding-y--24">
  <ea-button-loader
    buttonClass="container bl-width--100 bl-button bl-button--primary"
    buttonId="one-click-accept-btn"
    buttonType="button"
    text="Accept Offer"
    class="container bl-width--100"
    [loading]="isLoading()"
    (event)="acceptOffer()"
  ></ea-button-loader>
</section>
